module.exports = __webpack_public_path__ + "media/images/resell-unselect-e7803748.png";